import { render, staticRenderFns } from "./grouped-associate-info.vue?vue&type=template&id=096de1b7&scoped=true&"
import script from "./grouped-associate-info.vue?vue&type=script&lang=js&"
export * from "./grouped-associate-info.vue?vue&type=script&lang=js&"
import style0 from "./grouped-associate-info.vue?vue&type=style&index=0&id=096de1b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096de1b7",
  null
  
)

export default component.exports